<template>
    <div class="card form-sign-in">
        <div class="card-header">{{t('Reset password')}}</div>
        <div class="card-body text-center" v-if="validating === true">
            <loading/>
            <span class="d-block mt-2">{{t('Validating your account')}}</span>
        </div>
        <div class="card-body text-center" v-if="loading === true">
            <loading/>
            <span class="d-block mt-2">{{t('Resetting password')}}</span>
        </div>
        <div class="card-body" v-if="loading === false && validating === false">
            <titan-form ref="resetPasswordForm"
                        :schema="schema"
                        :renderInCard="false"
                        :model="formData"
                        @saveData="sendForm()"
            />
            <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
                {{t('Reset password')}}
            </button>
        </div>
    </div>
</template>
<script>
    import TitanForm from '../../Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../loading';

    export default {
        components: {
            Loading,
            TitanForm
        },
        props: {
            resetPassword: {
                type: Function,
                required: true,
            },
            validateToken: {
                type: Function,
                required: true,
            },
            minLength: {
                type: Number,
                default: 8,
            },
            userId: {
                type: Number,
                required: true,
            },
            hash: {
                type: String,
                required: true,
            }
        },
        mounted() {
            this.validateHash();
        },
        methods: {
            validateHash() {
                this.validating = true;
                this.validateToken({id: this.userId, hash: this.hash}).then(res => {
                    this.validating = false;
                }).catch(error => {
                    this.validating = false;
                    this.$emit('tokenNotFound');
                });
            },
            sendForm() {
                if (this.$refs.resetPasswordForm.isValid() === true) {
                    this.loading = true;

                    const data = {...this.formData};
                    data.id = this.userId;
                    data.hash = this.hash;

                    this.resetPassword(data).then(response => {
                        this.loading = false;
                        this.$emit('success');
                    }).catch(error => {
                        this.loading = false;
                        this.$emit('failedToResetPassword', error);
                    });
                }
            },
        },
        data() {
            return {
                validating: true,
                loading: false,
                schema: [
                    {
                        name: '',
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Password'),
                                model: 'newPassword',
                                required: true,
                                min: this.minLength,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('Password again'),
                                model: 'newPasswordAgain',
                                required: true,
                                validator: () => {
                                    if (this.formData.newPassword !== this.formData.newPasswordAgain) {
                                        return [this.t('Both passwords must be equal.')]
                                    }
                                    return [];
                                }
                            }
                        ]
                    }
                ],
                formData: {
                    newPassword: '',
                    newPasswordAgain: '',
                }
            }
        }
    }
</script>
<style lang="scss">
    .form-sign-in {
        .forgotten-password {
            margin-top: -5px;
            text-align: right;
            margin-bottom: 15px;

            a {
                color: #8e8e8e;
                font-size: 15px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/core/Components/User/ResetPassword.vue